import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import Dataset from '../model/Dataset';
import AbstractRestService from './abstract-rest-service.interface';
import { EnvironmentService } from './environment.service';

@Injectable({
  providedIn: 'root',
})
export class DatasetStore extends AbstractRestService<Dataset> {
  constructor(http: HttpClient, env: EnvironmentService) {
    super(http, env.datasetsFetchUrl);
  }
}
